export default [
    {
      path: '/admin/reports/sale/visitation-plans',
      name: 'visitation-plan',
      meta: { requiresAuth: true },
      component: () => import('@/pages/report/sale/visitation-plan.vue')
    }
]